(() => {
 const marked=new WeakSet();
 function sync(){
  const blocked=!!document.querySelector('[data-nlx-cart-state="blocked"]');
  document.querySelectorAll('button[name="checkout"]').forEach(button=>{
   if(blocked){if(!button.disabled){marked.add(button);button.disabled=true;}}
   else if(marked.has(button)){button.disabled=false;marked.delete(button);}
  });
  document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(el=>{el.hidden=blocked;});
 }
 function stop(event){
  if(!document.querySelector('[data-nlx-cart-state="blocked"]'))return;
  const target=event.target instanceof Element?event.target:null;
  const checkout=event.type==='submit' ? (event.submitter?.name==='checkout') : target?.closest('[name="checkout"],a[href="/checkout"]');
  if(!checkout)return;
  event.preventDefault();event.stopImmediatePropagation();
  const warning=document.querySelector('.nlx-cart-warning');warning?.focus();warning?.scrollIntoView({block:'center',behavior:'smooth'});
 }
 document.addEventListener('click',stop,true);document.addEventListener('submit',stop,true);
 let queued=false;const observer=new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});});
 if(document.body){observer.observe(document.body,{childList:true,subtree:true});sync();}
})();